export const ImapEnum = {
  NEDESIFRIRANA_POVEZAVA_Z_AVTENTIKACIJO: '143',
  SIFRIRANA_POVEZAVA_PREK_SSL_ALI_TLS_PROTOKOLA: '993',
  SIFRIRANA_POVEZAVA_PREK_STARTLS_PROTOKOLA: '143'
}



// WEBPACK FOOTER //
// ./src/assets/js/Enum/ElektronskaPostaNastavitve/ImapEnum.js